module.exports = __webpack_public_path__ + "static/media/experienceStatsImage.3378f633.svg";